import {
  FrequencyUnit,
  HabitSchedule,
  InsightsTimeframes,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { getScheduleFrequency } from '@griply/utils';
import { useMemo } from 'react';

import { useActiveSchedule } from './use-active-schedule';
import { useSchedulesPerfectSlots } from './use-schedules-perfect-slots';

const frequencyTimeframeMap = {
  [FrequencyUnit.Week]: [
    InsightsTimeframes.Week,
    InsightsTimeframes.Month,
    InsightsTimeframes.Quarter,
    InsightsTimeframes.Year,
    InsightsTimeframes.FourWeeks,
    InsightsTimeframes.TwelveWeeks,
    InsightsTimeframes.TwelveMonths,
  ],
  [FrequencyUnit.Month]: [
    InsightsTimeframes.Month,
    InsightsTimeframes.Quarter,
    InsightsTimeframes.Year,
    InsightsTimeframes.TwelveMonths,
  ],
  [FrequencyUnit.Year]: [InsightsTimeframes.Year],
};

export type Options = {
  timeframe: InsightsTimeframes;
  startDate: Timestamp;
  endDate: Timestamp;
  weekStartsOn: WeekDays;
  today: Timestamp;
};

export const useInsightTimeframePerfectSlots = (
  schedules: HabitSchedule[],
  { timeframe, startDate, endDate, weekStartsOn, today }: Options,
) => {
  const activeSchedule = useActiveSchedule(schedules, today);
  const perfectSlots = useSchedulesPerfectSlots(schedules, {
    startDate,
    endDate,
    weekStartsOn,
    strictDates: true,
    today,
  });

  return useMemo(() => {
    if (!activeSchedule) {
      return [];
    }

    const frequency = getScheduleFrequency(activeSchedule);
    if (!frequencyTimeframeMap[frequency].includes(timeframe)) {
      return [];
    }

    return perfectSlots;
  }, [activeSchedule, perfectSlots, timeframe]);
};
